import React, {useEffect, useRef, useState} from "react";
import {get} from "axios";
import {CircularProgress} from "@material-ui/core";

export default function Iframe(props) {
    const {url} = props
    const [loading, setLoading] = useState(false);
    const [htmlsrc, sethtmlsrc] = useState("");
    const [iframeHeight, setIframeHeight] = useState(1000);
    const iframe = useRef(null);
    const fixedHeight = 2000;


    useEffect(() => {
        getIframe();
    }, [props.url]);

    // Deprecated
    const getIframe = async () => {
        let htmlLink = url;
        let content = null;
        if (!!htmlLink) {
            // axios is sensible on URLs...
            const url = new URL(htmlLink);
            setLoading(true);
            content = await get(url.toString());
            content = content.data;
            content = content.replace("<head>", `<head><base href="${htmlLink}">`);
            setLoading(false);
            sethtmlsrc(content);
        }

    };

    // Deprecated
    function useWindowResizeListener(callback) {


        useEffect(() => {
            // Handler to call on window resize
            function handleResize() {
                // Set window width/height to state
                callback();
            }

            // Add event listener
            window.addEventListener("resize", handleResize);

            // Call handler right away so state gets updated with initial window size
            handleResize(callback);

            // Remove event listener on cleanup
            return () => window.removeEventListener("resize", handleResize);
        }, []); // Empty array ensures that effect is only run on mount

    }

    // Deprecated
    const resize = () => {
        let iframeElement = iframe["current"];
        if (iframeElement) {
            const body = iframeElement.contentWindow.document.body;
            if (body) {
                setIframeHeight(body.scrollHeight);
            }
        }
    };

    useWindowResizeListener(resize);

    return (
        <>
            {loading ? <CircularProgress color="secondary"/> :
                <iframe title="iframe" {...props} frameBorder="0" ref={iframe}
                        style={{ height: fixedHeight + "px"}}
                        id={"iframe"}
                        src={url} width={"100%"}/>
            }
        </>
    )}
